import qs from "qs";
import { ID_FILTER_REPORT_CREATIONDATEFROM, ID_FILTER_REPORT_CREATIONDATETO, ID_FILTER_SEARCH, ID_FILTER_LEGAL_ENTITIES, ID_FILTER_DEALERS } from "../../pages/royalties/constants/RoyaltiesFilters";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import dayjs from "dayjs";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useRoyaltiesReportRepository = () => {

    const { GET, POST } = useApi();
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
        

    const PATH = "/finance/contractor"

    function getReports(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_REPORT_CREATIONDATEFROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_REPORT_CREATIONDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);
        
        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            from: dateFrom ? dayjs(dateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null,
            to: dateTo ? dayjs(dateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null,
            legalEntities, 
            dealers
        }

        return GET(`${PATH}/royalty-printout-request/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getReportById(id: string, config?: any): Promise<HTTPGenericResponse> {
        return GET(`${PATH}/royalty-printout-request/${id}`, config);
    }

    function postPrintoutRequest(printoutRequest: any): Promise<HTTPGenericResponse> {
        return POST(`${PATH}/royalty-printout-request`, printoutRequest, {}, true);
    }

    return { getReports, getReportById, postPrintoutRequest };
}